<mat-toolbar color="primary" class="mat-elevation-z8 position-fixed">

    <ng-container *ngIf="is_show_menu">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    </ng-container>

    <span>Angle Attribution</span>
    <span *ngIf="role==='superadmin'" style="margin-left: 5px">{{role}}</span>
    <span class="example-spacer"></span>
    <span>  {{account_name}}</span>
    <span style="padding-right:15px;padding-left:15px"></span>
    <span style="padding-right:15px;padding-left:15px"></span>
    <span *ngIf="!is_login_route">

      <!-- BUTTON CAUSES THE ICON TO ADD TOP PADDING OR MARGINS.  LETS FIX-->
      <button mat-icon-button (click)="onClickNotifications()">
        <ng-container *ngIf="notification_count>0">
          <mat-icon matBadge="{{notification_count}}" matBadgeOverlap="true" matBadgeColor="warn">notifications</mat-icon>
        </ng-container>
        <ng-container *ngIf="notification_count==0">
        <mat-icon>notifications</mat-icon>
        </ng-container>
      </button>


      <mat-menu class="dropdown-menu" #appMenu="matMenu">
        <button mat-menu-item href="javascript:void(0)" (click)="userSettings()">
          <mat-icon class="add-button">settings</mat-icon>
          User Settings
        </button>
        <button mat-menu-item href="javascript:void(0)" (click)="logout()">
          <mat-icon class="add-button">logout</mat-icon>
          Logout</button>
      </mat-menu>
      <button mat-icon-button [matMenuTriggerFor]="appMenu">
          <mat-icon>more_vert</mat-icon>
      </button>
    </span>
</mat-toolbar>

<!-- TODO NEED TO FIX POSTION FIXED.  IT DOES WHAT WE WANT BUT CAN ADHUST HEIGHT FOR CHILD COMPONENTS-->
<!--VERY IMPORTANT CSS PROPERTY POSTITION FIXED AND WITH 100%  <mat-sidenav-container class="sidenav-container"  style="position: fixed; width: 100%;"> -->
<mat-sidenav-container class="sidenav-container" style="overflow: hidden;">
  <mat-sidenav #drawer class="sidenav"
               fixedInViewport="false"
               [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
               [mode]="(isHandset$ | async) ? 'over' : 'side'"
               [opened]="(isHandset$ | async) === false ">

    <ng-container *ngIf="is_default_settings || is_user_settings || role==='superadmin'">
      <mat-nav-list>

        <ng-container *ngIf="role==='superadmin'">
        <a mat-list-item routerLinkActive="active" [routerLink]="['/agencys']" >
          <mat-icon class="add-button" style="margin-left: 10px;">arrow_back_ios_new</mat-icon>
          Agencys
        </a>
        </ng-container>

        <ng-container *ngIf="is_default_settings">
          <!-- <a mat-list-item href="javascript:void(0)" (click)="redirect('/accounts')">Accounts</a> -->
          <a mat-list-item routerLinkActive="active" [routerLink]="['/accounts',agency_id]">
            <mat-icon class="add-button" style="margin-left: 10px;">arrow_back_ios_new</mat-icon>
            Accounts</a>
          <a mat-list-item routerLinkActive="active" [routerLink]="['/dashboard',agency_id,account_id]" [queryParams]="{account_name: account_name}">
            <mat-icon class="add-button" style="margin-left: 10px;">dashboard</mat-icon>
            Dashboard</a>
          <mat-divider></mat-divider>
          <h2 mat-subheader>Integrations</h2>
          <a style="margin-left: 30px;" mat-list-item routerLinkActive="active" [routerLink]="['/integrations',agency_id,account_id]">Webhooks</a>
          <a style="margin-left: 30px;" mat-list-item routerLinkActive="active" [routerLink]="['/trackertag',agency_id,account_id]">Tracker Tag</a>
          <mat-divider></mat-divider>
          <h2 mat-subheader>Reports</h2>
          <a style="margin-left: 30px;" mat-list-item
             routerLinkActive="active"
             [routerLink]="['/agency/account/reports/',agency_id, account_id]"
             [queryParams]="{type: 'performance'}">Campaign Performance</a>
        </ng-container>
        <ng-container *ngIf="is_user_settings">
          <a mat-list-item href="javascript:void(0)" (click)="backToAccounts()">
            <mat-icon class="add-button" style="margin-left: 10px;">arrow_back_ios_new</mat-icon>
            Back To Account</a>
          <a mat-list-item routerLinkActive="active" [routerLink]="['/user','password']"
             [queryParams]="{is_user_settings: 'true',is_account_route: is_account_route}">
            <mat-icon class="add-button" style="margin-left: 10px;">password</mat-icon>
            Change Password</a>
        </ng-container>
      </mat-nav-list>
    </ng-container>
  </mat-sidenav>

  <mat-sidenav-content>
    <ng-content></ng-content>
    <!-- Add Content Here -->
  </mat-sidenav-content>
</mat-sidenav-container>
